import { map, takeUntil } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { BaseComponent } from '../base.component';
import { Ciudad } from 'src/app/models/ciudad.interface';
import { EnlacesService } from 'src/app/services/enlaces.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-ciudad',
  templateUrl: './ciudad.component.html',
  styleUrls: ['./ciudad.component.scss']
})
export class CiudadComponent extends BaseComponent implements OnInit {

  ciudades$: Observable<Ciudad[] | null> = this.enlacesService.getCiudades$()
  updatingCiudades$: Observable<boolean> = this.enlacesService.getUpdatingCiudades$();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private enlacesService: EnlacesService,
    private _location: Location) {
    super(_location);
  }

  ngOnInit(): void {
    this.activatedRoute.params
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((params: Params) => {
        if (params.estadoId) {
          this.enlacesService.getCiudadesAPI(params.estadoId, this.ngUnsubscribe);
        }
      })
  }

  public onClick(ciudadId: number) {
    this.router.navigate(['/farmacias', ciudadId]);
  }

}
